import { render, staticRenderFns } from "./booleanEditor.vue?vue&type=template&id=2b35cda2"
import script from "./booleanEditor.vue?vue&type=script&lang=js"
export * from "./booleanEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports